import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent {
  languages = [
    { code: 'pt', label: 'PT-BR', icon:'assets/flags/4x3/br.svg', name: 'Portuguese'},
    { code: 'en', label: 'EN', icon:'assets/flags/4x3/us.svg', name: 'English'},
    { code: 'cn', label: 'CN', icon:'assets/flags/4x3/cn.svg', name: 'Chinese'},
    { code: 'es', label: 'ES', icon:'assets/flags/4x3/es.svg', name: 'Spanish' },
    { code: 'ru', label: 'RU', icon:'', name: 'Russian'}
  ];

  constructor(private translate: TranslateService) {
    const saved = localStorage.getItem('lang');
    if (saved) this.translate.use(saved);
  }

  changeLang(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }

  getLang(code: string) {
    return this.languages.find(l => l.code === code);
  }


  current() {
    return this.translate.currentLang || this.translate.defaultLang;
  }
}
